import { z } from 'zod';
import { uuidSchema } from './common.schema.js';

export const BaseBedSchema = z.object({
  bed_id: uuidSchema,
  care_unit_id: uuidSchema,
  facility_id: uuidSchema,
  enterprise_id: uuidSchema,
  hospital_id: uuidSchema,
  tenant_id: uuidSchema,
  bed_number: z.string().max(20),
  bed_type: z.string().max(25),
  bed_status: z.string().max(20),
  bay_code: z.string().max(20).nullable(),
  room_number: z.string().max(20).nullable(),
  is_active: z.boolean(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type BaseBed = z.infer<typeof BaseBedSchema>;

/** Schema used to parse raw Prisma rows (Date -> ISO string) before returning */
export const BedResponseSchema = BaseBedSchema.extend({
  created_at: z.coerce.date().transform((d) => d.toISOString()),
  updated_at: z.coerce.date().transform((d) => d.toISOString()),
});

export type BedResponse = z.infer<typeof BedResponseSchema>;

export const CreateBedRequestSchema = z.object({
  careUnitId: uuidSchema,
  facilityId: uuidSchema,
  enterpriseId: uuidSchema,
  hospitalId: uuidSchema,
  tenantId: uuidSchema,
  bedNumber: z.string().min(1).max(20),
  bedType: z.string().min(1).max(25),
  bedStatus: z.string().max(20).default('AVAILABLE'),
  bayCode: z.string().max(20).nullable().optional(),
  roomNumber: z.string().max(20).nullable().optional(),
  isActive: z.boolean().default(true),
});

export type CreateBedRequest = z.infer<typeof CreateBedRequestSchema>;
